import type { ScheduleGroup } from '../types/schedule-groups';
import type { Lesson } from '../types/lessons';
import type { OutTypes } from './schedules';

export default function (
  scheduleGroups: ScheduleGroup[] | undefined,
  lessons:        Lesson[] | undefined,
  importErrors:   string[],
  importWarnings: string[],
): OutTypes.teacher[] {
  // add all teachers to a set to remove duplicates
  const teacherSet: Map<number, OutTypes.teacher> = new Map();

  scheduleGroups?.forEach(scheduleGroup => {
    scheduleGroup.teachers?.forEach(teacher => {
      teacherSet.set(teacher.id, {
        ids:         teacher.id.toString(),
        displayName: teacher.first_name + ' ' + teacher.last_name
      });
    });
  });

  lessons?.forEach(lesson => {
    lesson.teachers?.forEach(teacher => {
      teacherSet.set(teacher.id, {
        ids:         teacher.id.toString(),
        displayName: teacher.first_name + ' ' + teacher.last_name
      });
    });
  });

  return Array.from(teacherSet.values());
}
